import React,{useState,useEffect} from 'react'
import {Row,Col,Card,Button,Avatar,Typography,Dropdown,Radio,Divider,Layout, Table, Tooltip} from "antd";
import { UserOutlined, UnlockOutlined, KeyOutlined,ContactsOutlined,MobileOutlined, ReloadOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SiderBar from './SiderBar';
import signinbg from "../../assets/images/c.jpg";

const { Content} = Layout;

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  }
];


const ApiParameters = () => {
    const [Islive, setIslive] = useState(false);
    const { user: currentUser } = useSelector((state) => state.auth); 
    const [isCopied, setIsCopied] = useState(false);
    const navigate = useNavigate();
    console.log(currentUser);
    if (!currentUser) {
      navigate('/')
    
    }

    const data = [
      {
        key: 1,
        name: <h5><ContactsOutlined /> Client Code</h5>,
        description: <p style={{color:'green'}}>{currentUser.ClientCode}</p>,
      },
      {
        key: 2,
        name: <h5><UserOutlined /> Client Name</h5>,
        description: <p style={{color:'green'}}>{currentUser.ClientName}</p>,
      },
      {
        key: 3,
        name: <h5><KeyOutlined /> API key</h5>,
        description: <p style={{color:'green'}}>{currentUser.ClientApikey}<Tooltip title="Reset">
        <Button type="secondary" shape="circle" icon={<ReloadOutlined />} />
      </Tooltip></p>,
      },
      {
        key: 4,
        name: <h5><MobileOutlined /> Cpay Merchant Code</h5>,
        description: <p style={{color:'green'}}>{currentUser.MerchantNumber}</p>,
      },
      {
        key: 5,
        name: <h5><UnlockOutlined /> Client Secret</h5>,
        description: <p style={{color:'green'}}>{currentUser.ClientSecret}</p>,
      },
    ];

    return (     
      <Content style={{marginTop:'5%'}}>  
      <Layout hasSider >
      <SiderBar props='3'/>

      <Layout className="site-layout" >
        <Content style={{ margin: '10px 0px 0', overflow: 'initial' }}>  
          <div className="tabled" style={{margin:' 0 0.5%', backgroundImage:'url('+signinbg+')'}}>
            
          <Row gutter={[16,16]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Card title="API Test Credentials" style={{margin:'2% 5%',height:'93%'}}>
                <Table
                  columns={columns}
                  expandable={{
                    expandedRowRender: (record) => (
                      <p
                        style={{
                          margin: 0,
                        }}
                      >
                        {record.description}
                      </p>
                    ),
                    rowExpandable: (record) => record.name !== 'Not Expandable',
                  }}
                  dataSource={data}
                />

              </Card>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              {Islive?
              <Card className="api_card" title="Live credentials" style={{margin:'2% 5%',height:'93%'}}>
                <h5><ContactsOutlined /> Client Code</h5>
                <p>{currentUser.ClientCode}</p>
                <Divider/>
                <h5><UserOutlined /> Client Name</h5>
                <p>{currentUser.ClientName}</p>
                <Divider/>
                <h5><KeyOutlined /> API key</h5>
                <p>{currentUser.ClientApikey}</p>
                <Divider/>
                <h5><MobileOutlined /> Cpay Merchant Number</h5>
                <p>{currentUser.MerchantNumber}</p>
                <Divider/>
                <h5><UnlockOutlined /> Client secret</h5>
                <p>{currentUser.ClientSecret}</p>
                </Card>:
              <Card className="api_card" title="Live credentials" style={{margin:'2% 5%',height:'93%'}}>
                <Button>Click here to generate live credentials</Button>
              </Card>}
              </Col>
              </Row>
          </div>
    </Content>
    </Layout>
    </Layout>
    </Content>  
    )
}

export default ApiParameters